export const HANGING_RANSOM = {
  MONTH: 'month',
  COUNTRY: 'country',
  REGION: 'region',
  OFFER_GROUP: 'offer_group',
  OFFER_NICHE: 'offer_niche',
  DELIVERY_SERVICE: 'delivery_service',
  SALES_MODEL: 'sales_model',
}
